import backgroundImage from '@assets/auth-background.jpg'
import { AuthHeader } from '@components/layout/components/AuthHeader'
import Box from '@mui/material/Box'
import type { ReactNode } from 'react'

interface LayoutProps {
  children?: ReactNode
}

export const AuthLayout = ({ children }: LayoutProps) => {
  return (
    <Box
      display="grid"
      gridTemplateRows="auto 1fr auto"
      rowGap={1}
      sx={{ height: '100vh', width: '100%', background: (t) => t.palette.background.paper }}
    >
      <Box sx={{ pt: 1 }}>
        <AuthHeader />
      </Box>
      <Box
        sx={{
          height: '100%',
          background: (theme) => theme.palette.background.default,
          backgroundImage: `url(${backgroundImage})`,
          backgroundSize: { xs: '100% 100%', md: '60% 100%' },
          backgroundRepeat: 'no-repeat',
        }}
      >
        <Box
          sx={{
            width: '100%',
            height: '100%',
            background: (theme) =>
              `linear-gradient(270deg, ${theme.palette.background.default} 0%, ${theme.palette.background.default} 40%, rgba(255, 255, 255, 0) 70% ,rgba(255, 255, 255, 0) 100%)`,
          }}
        >
          {children}
        </Box>
      </Box>
    </Box>
  )
}
